import { Component, Input, TemplateRef, ViewChild } from "@angular/core";
import { RoleMgr, ShowRequest } from "../../core";
import { AppTab } from "../../core/app-tab";
import { TaskStatus } from "../../core/models";
import { TableRecsAction } from "../../shared/components/table-view/table-view-action";
import {
  VolunteerTaskRecord
} from "../models/volunteer-task-record";
import { VolunteerTasksTableComponent } from "./volunteer-tasks-table.component";
import { TableViewQueryResponse } from "../../shared/components/table-view/table-view-component-base";

type TaskStats = {
  callsCompletePct: number;
  totalCalls: number;
  totalMissingCalls: number;
  targetTotalCalls: number;

  notStarted: number;
  inProgress: number;
  complete: number;
  fieldComplete: number;
  nextEndDate: string;
};

type GroupedCallCountTotals = {
  groupName: string;
  totalCalls: ({ groupKey: string, title: string} & TaskStats)[];
};


@Component({
  selector: "app-volunteer-task-list",
  templateUrl: "volunteer-task-list.component.html",
  styleUrls: ["volunteer-task-list.component.scss"],
})
export class VolunteerTaskListComponent {


  @Input() tabConfig: AppTab;

  @Input() detailFn: (vi: ShowRequest) => void;

  @Input() contextJson: string;

  @Input() contextJsonChangeHandler: (itemId: string, tab: AppTab) => void;

  @ViewChild("volunteerTasksTable") taskTable: VolunteerTasksTableComponent;
  @ViewChild("chooseVolunteerTmpl") chooseVolunteerTmpl: TemplateRef<any>;

  bTabSelected = false;

  constructor(public roleMgr: RoleMgr) {}

  // some hacks to type check cell renderer template before checking in
  // Temporarly uncomment in template html to do type checking (don't check in uncommented!!!)
  //typedRecord = (r: VolunteerTaskViewRecord) => r;
  //typedColumn = (c: TableColumn) => c;

  statuses = TaskStatus.Ids;

  getStatusName(statusName: any) {
    return TaskStatus.getStatusName(statusName);
  }

  async doAction(
    action: TableRecsAction<VolunteerTaskRecord>,
    rec: VolunteerTaskRecord
  ) {
    try {
      this.taskTable.errorMsg = null;
      const result = await action.recsAction({recs:[rec],action});
      console.log(JSON.stringify(result));
      this.taskTable.errorMsg = result.ok ? null : result.msg;
    } catch (error: any) {
      const msg = error?.message || `${error?.message}`;
      this.taskTable.errorMsg = msg;
    } 
  }

  totalCalls: TaskStats;
  groupedTotalCalls: GroupedCallCountTotals;
  horizontalGroupings = true;

  onTableResponse(resp: TableViewQueryResponse<VolunteerTaskRecord>){
    this.totalCalls = resp['totalCallsResult'];
    this.groupedTotalCalls = resp['groupedTotalCallsResult'];
  }


}
